// FirsatDeneme.jsx — SMS kampanyasi: 7 gun ucretsiz + kart formu -> recurring/start (980/ay)
// TEST ortami. Mevcut konvansiyon: /api proxy, Bearer biyz_token, MUI.
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Box, Card, CardContent, Typography, Button, CircularProgress,
  Alert, TextField, Divider, Chip, Stack,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const token = () => localStorage.getItem("biyz_token");
const authHead = () => ({ Authorization: `Bearer ${token()}`, "Content-Type": "application/json" });

// Kampanya: normal 1400 -> %30 indirim -> 980. Kod opsiyonel (yoksa paket fiyati uygulanir).
const KAMPANYA_KODU = "biuzman";
const TRIAL_DAYS = 7;

export default function FirsatDeneme() {
  const location = useLocation();
  const egitim = (new URLSearchParams(location.search).get("egitim") || "").trim();

  const [loading, setLoading] = useState(true);
  const [pkg, setPkg] = useState(null);
  const [allPaid, setAllPaid] = useState([]);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(null);

  const [card, setCard] = useState({ name: "", number: "", exp: "", cvv: "" });
  const [accept, setAccept] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("/api/packages", { headers: authHead() });
        const d = await r.json();
        const list = (Array.isArray(d) ? d : (d?.data || [])).filter(p => p?.isActive !== false);
        const paid = list.filter(p => Number(p.price) > 0);
        setAllPaid(paid);
        if (egitim) {
          const matches = paid.filter(p =>
            (p.name || "").toLowerCase().includes(egitim.toLowerCase()) ||
            (Array.isArray(p.bots) && p.bots.some(b => String(b).toLowerCase().includes(egitim.toLowerCase())))
          );
          matches.sort((a, b) => Number(a.price) - Number(b.price)); // en ucuz = Basic
          setPkg(matches[0] || null);
        }
      } catch {
        setError("Paketler yuklenemedi. Once giris yaptiginizdan emin olun.");
      } finally {
        setLoading(false);
      }
    })();
  }, [egitim]);

  const fmtPrice = (p) => (Number(p) || 0).toLocaleString("tr-TR");

  const submit = async () => {
    setError("");
    if (!pkg) { setError("Egitim secilmedi."); return; }
    const digits = card.number.replace(/\D/g, "");
    const [mm, yy] = card.exp.split("/").map(s => (s || "").trim());
    if (!card.name || digits.length < 12 || !mm || !yy || card.cvv.length < 3) {
      setError("Lutfen kart bilgilerini eksiksiz girin."); return;
    }
    if (!accept) { setError("Devam etmek icin kosullari onaylayin."); return; }
    setSubmitting(true);
    try {
      const body = {
        packageId: pkg._id,
        trialDays: TRIAL_DAYS,
        campaignCode: KAMPANYA_KODU,
        card: {
          CC_OWNER: card.name,
          CC_NUMBER: digits,
          EXP_MONTH: mm,
          EXP_YEAR: yy.length === 2 ? "20" + yy : yy,
          CC_CVV: card.cvv,
        },
      };
      const r = await fetch("/api/payments/esnekpos/recurring/start", {
        method: "POST", headers: authHead(), body: JSON.stringify(body),
      });
      const d = await r.json();
      if (r.ok && d.ok) {
        setDone(d);
      } else {
        setError(d?.detail?.message || d?.error || "Abonelik baslatilamadi. Karti kontrol edip tekrar deneyin.");
      }
    } catch {
      setError("Baglanti hatasi. Tekrar deneyin.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}><CircularProgress /></Box>;
  }

  if (done) {
    return (
      <Box sx={{ maxWidth: 520, mx: "auto", mt: 6, textAlign: "center", px: 2 }}>
        <CheckCircleIcon sx={{ fontSize: 64, color: "success.main" }} />
        <Typography variant="h5" sx={{ mt: 1, fontWeight: 800 }}>Hos geldin! 🎉</Typography>
        <Typography sx={{ color: "text.secondary", mt: 1 }}>
          {pkg?.name} icin <b>{TRIAL_DAYS} gunluk ucretsiz denemen</b> basladi. Su an kartindan hicbir ucret alinmadi.
        </Typography>
        <Typography sx={{ color: "text.secondary", mt: 1, fontSize: 14 }}>
          {done.trialEndDate} tarihinde iptal etmezsen aylik {fmtPrice(done.amount)} ₺ cekilir; panelden tek tikla iptal edebilirsin.
        </Typography>
        <Button variant="contained" sx={{ mt: 3 }} href="/chat">Egitime Basla →</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 560, mx: "auto", mt: 4, px: 2, pb: 6 }}>
      <Typography variant="h5" sx={{ fontWeight: 800, textAlign: "center" }}>Sana Ozel Firsat 🎁</Typography>
      <Typography sx={{ color: "text.secondary", textAlign: "center", mt: 0.5 }}>
        7 gun ucretsiz dene — begenirsen sana ozel %30 indirimle devam et
      </Typography>

      {!egitim && (
        <Alert severity="info" sx={{ mt: 2 }}>
          Once bir egitim secin: {allPaid.slice(0, 12).map(p => (
            <Chip key={p._id} label={p.name} size="small" sx={{ m: 0.3 }}
              onClick={() => { window.location.search = "?egitim=" + encodeURIComponent(p.name.split(" ")[0]); }} />
          ))}
        </Alert>
      )}

      {egitim && !pkg && (
        <Alert severity="warning" sx={{ mt: 2 }}>"{egitim}" icin uygun paket bulunamadi.</Alert>
      )}

      {pkg && (
        <Card sx={{ mt: 3, borderRadius: 3 }}>
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>{pkg.name}</Typography>
            <Stack spacing={0.5} sx={{ mt: 1.5, mb: 1 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <span>Ilk 7 gun</span><b style={{ color: "#16a34a" }}>UCRETSIZ — 0 ₺</b>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", color: "#6b7785" }}>
                <span>Normal aylik</span><span style={{ textDecoration: "line-through" }}>{fmtPrice(pkg.price)} ₺</span>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", fontWeight: 800 }}>
                <span>7 gun sonra sana ozel</span><span>980 ₺/ay <small style={{ color: "#16a34a" }}>(%30)</small></span>
              </Box>
            </Stack>

            <Alert severity="info" icon={false} sx={{ my: 2, fontSize: 13 }}>
              <b>Net bilgilendirme:</b> Ilk 7 gun tamamen ucretsizdir, kartindan <b>hicbir tahsilat yapilmaz</b>.
              7. gunun sonunda iptal etmezsen kartindan <b>aylik 980 ₺</b> cekilir. Cekimden 1-2 gun once hatirlatma
              gonderilir. Panelinden <b>tek tikla, istedigin an</b> iptal edebilirsin.
            </Alert>

            <Divider sx={{ mb: 2 }} />
            <Stack spacing={2}>
              <TextField label="Kart Uzerindeki Isim" fullWidth value={card.name}
                onChange={e => setCard({ ...card, name: e.target.value })} />
              <TextField label="Kart Numarasi" fullWidth value={card.number} placeholder="0000 0000 0000 0000"
                onChange={e => setCard({ ...card, number: e.target.value })} />
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField label="Son Kullanma (AA/YY)" fullWidth value={card.exp} placeholder="08/29"
                  onChange={e => setCard({ ...card, exp: e.target.value })} />
                <TextField label="CVV" fullWidth value={card.cvv} placeholder="123"
                  onChange={e => setCard({ ...card, cvv: e.target.value.replace(/\D/g, "") })} />
              </Box>
              <label style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 13, color: "#3a4757" }}>
                <input type="checkbox" checked={accept} onChange={e => setAccept(e.target.checked)} style={{ marginTop: 3 }} />
                <span>7 gun ucretsiz deneme ve sonrasinda 980 ₺/ay otomatik yenileme kosullarini okudum, onayliyorum.</span>
              </label>

              {error && <Alert severity="error">{error}</Alert>}

              <Button variant="contained" size="large" disabled={submitting} onClick={submit}
                sx={{ fontWeight: 800, py: 1.4 }}>
                {submitting ? "Baslatiliyor..." : "7 Gunluk Ucretsiz Denememi Baslat →"}
              </Button>
              <Typography sx={{ textAlign: "center", color: "text.secondary", fontSize: 12 }}>
                <LockIcon sx={{ fontSize: 13, verticalAlign: "middle" }} /> Guvenli odeme · Ilk 7 gun 0 ₺ · Tek tikla iptal
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      )}
    </Box>
  );
}

